import {
    NOTIFICATION_SHOW,
    NOTIFICATION_HIDE,
    NOTIFICATION_SHOWED,
    NOTIFICATION_HID
} from "../consts/consts";

const initialState = {
    status: NOTIFICATION_HIDE,
    message: "",
    duration: 1500
};

const showNotification = (message = "", duration = 1500) => {
    return {
        status: NOTIFICATION_SHOW,
        message: message,
        duration: duration
    }
};

const updateNotification = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case NOTIFICATION_SHOWED:
            return showNotification(action.payload.message, action.payload.duration);
        case NOTIFICATION_HID:
            return initialState;
        default:
            return state.notification;
    }
};

export {
    updateNotification
}